import React from 'react';
import Highlighter from "react-highlight-words";
import Icons from './ui/Icons';
import { useRecoilValue } from 'recoil';
import { searchState } from '../state/searchState';

export const TabellaTariffario = ({ tariffe = [] }) => {
    const search_string = useRecoilValue(searchState);

    return (
        <table className="tabellaTariffario">
            <tbody>
                <tr>
                    <th>Progressivo</th>
                    <th>Descrizione tariffa</th>
                    <th style={{textAlign: 'right'}}>Importo</th>
                </tr>

                {tariffe.map((tariffa, index) => (
                    <tr key={`tariffa_${index}`}>
                        <td>{tariffa.Progressivo}</td>
                        <td>
                            <Highlighter
                                highlightClassName="YourHighlightClass"
                                searchWords={[search_string]}
                                autoEscape={true}
                                textToHighlight={(tariffa.Descrizione ?? "").replace(/(<([^>]+)>)/ig, '')} />
                            <Icons tariffa={tariffa}/>
                        </td>
                        <td style={{textAlign: 'right'}}>
                            <p className="diretto">{tariffa.ImportoDiretta != "" ? "Indiretto" : ""}</p><span>{tariffa.Importo}</span>
                            {tariffa.ImportoDiretta != "" ? (
                                <React.Fragment>
                                    <p className="indiretto"> Diretto </p>
                                    <span>
                                        {tariffa.ImportoDiretta}
                                    </span>
                                </React.Fragment>
                            ) : null
                            }

                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
